import React from 'react'
import Photo from './Photo'

const MainPhoto = ({ item, canBuy = true }) => {
  if (item.photos && item.photos.length > 0) {
    const mainPhoto = item.photos[0]
    return <Photo photo={mainPhoto} canBuy={canBuy} />
  }
  return null
}

export default MainPhoto
